import * as React from "react";
import { NavLink } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";

import {
    faAngleLeft,
    faArrowDown,
    faArrowUp,
    faChartArea,
    faFileInvoiceDollar,
    faGavel,
    faHorseHead,
    faUsers
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
    toogleSideBar: () => void;
    showSideBar: boolean;
}
interface State {
    showHFSSubmenu: boolean;
    showCustomerSubmenu: boolean;
    width: number;
}

export default class MainNavigation extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            showHFSSubmenu: false,
            showCustomerSubmenu: false,
            width: 0
        };
    }

    toggleMenu = () => {
        this.setState({ showHFSSubmenu: !this.state.showHFSSubmenu });
    };

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth });
    };

    render() {
        return (
            <nav
                className={`main-navigation 
                    ${this.state.width < 992 ? (this.props.showSideBar ? `showSideBar` : ``) : this.props.showSideBar ? `` : `showSideBar`}`}
            >
                <div className="nav-header">
                    <div className="nav-title">MENU</div>
                    <button className="nav-button" id="tooltipToogleSidebar" onClick={this.props.toogleSideBar}>
                        <FontAwesomeIcon icon={faArrowDown} rotation={!this.props.showSideBar ? 90 : 270} className="button-icon-large" />
                        <FontAwesomeIcon icon={faArrowUp} rotation={!this.props.showSideBar ? 90 : 270} className="button-icon-small" />
                    </button>
                    <UncontrolledTooltip placement="right" target="tooltipToogleSidebar" delay={0} className="tooltipstrap">
                        {this.state.width > 992
                            ? !this.props.showSideBar
                                ? "Minimize Main Menu"
                                : "Expand Main Menu"
                            : !this.props.showSideBar
                            ? "Expand Main Menu"
                            : "Minimize Main Menu"}
                    </UncontrolledTooltip>
                </div>
                <ul className={this.state.width > 992 ? (this.props.showSideBar ? `showSideBar` : ``) : this.props.showSideBar ? `` : `showSideBar`}>
                    <li>
                        <NavLink className="link-aplication" to="/customers" activeClassName="active">
                            <div className="div-icon">
                                <FontAwesomeIcon className="icon" icon={faUsers} />
                            </div>
                            <div className="title">Customers</div>
                            <div
                                className="submenu"
                                onClick={e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    this.setState({ showCustomerSubmenu: !this.state.showCustomerSubmenu });
                                }}
                            >
                                <FontAwesomeIcon className="icon" rotation={this.state.showCustomerSubmenu === false ? 270 : 90} icon={faAngleLeft} />
                            </div>
                        </NavLink>
                        <ul className={"" + (this.state.showCustomerSubmenu === false ? "" : " showMenu")}>
                            <li>
                                <NavLink to="/generate-interest-invoices">Generate Interest Invoices</NavLink>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <NavLink className="link-aplication" to="/horses" activeClassName="active">
                            <div className="div-icon">
                                <FontAwesomeIcon className="icon" icon={faHorseHead} />
                            </div>
                            <div className="title">Horses</div>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink className="link-aplication" to="/horses-for-sale" activeClassName="active">
                            <div className="div-icon">
                                <FontAwesomeIcon className="icon" icon={faGavel} />
                            </div>
                            <div className="title">Horses for Sale </div>
                            <div
                                className="submenu"
                                onClick={e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    this.toggleMenu();
                                }}
                            >
                                <FontAwesomeIcon className="icon" rotation={this.state.showHFSSubmenu === false ? 270 : 90} icon={faAngleLeft} />
                            </div>
                        </NavLink>
                        <ul className={"" + (this.state.showHFSSubmenu === false ? "" : " showMenu")}>
                            <li>
                                <NavLink to="/horses-for-sale/address-map">Google Map of Addresses</NavLink>
                            </li>
                            <li>
                                <NavLink to="/horses-for-sale/pre-filled-forms">Pre-Filled Forms</NavLink>
                            </li>
                            <li>
                                <NavLink to="/horses-for-sale/assign-day-and-generate-hip-number">
                                    Assign Day of the Sale &amp; Generate Hip #
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/horses-for-sale/assign-spot-agripex">Assign Spot in the Agriplex</NavLink>
                            </li>
                            <li>
                                <NavLink to="/horses-for-sale/generate-entry-fee-invoices">Generate Entry Fee Invoices</NavLink>
                            </li>
                            <li>
                                <NavLink to="/horses-for-sale/winning-bidders-pictures">Winning Bidders Pictures</NavLink>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <NavLink className="link-aplication" to="/reports/customer-emails" activeClassName="active">
                            <div className="div-icon">
                                <FontAwesomeIcon className="icon" icon={faChartArea} />
                            </div>
                            <div className="title">Reports</div>
                        </NavLink>
                    </li>
                </ul>
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/MainNavigation.tsx